// extracted by mini-css-extract-plugin
module.exports = {"container":"FormFiles_container__v-KCx","column":"FormFiles_column__1nSDF","img":"FormFiles_img__1a3TY","del":"FormFiles_del__26F8R"};